import React, { useEffect, useRef } from "react";

const AppointmentScheduler = () => {
  const schedulerRef = useRef(null);

  // Функція для відображення віджету
  const openScheduler = () => {
    window.supersaas_721079.show();
  };

  useEffect(() => {
    // Ініціалізуємо віджет при монтажі компоненту
    const script = document.createElement("script");
    script.src = "https://cdn.supersaas.net/widget.js";
    script.async = true;
    document.head.appendChild(script);

    const widgetScript = document.createElement("script");
    widgetScript.innerHTML = `
      var supersaas_721079 = new SuperSaaS("537745:Maxhospee", "721079:Bergedorf_test", {
        "menu_pos": "bottom",
        "autoselect": "first_available",
        "finish_time": "hide",
        "domain": "www.supersaas.de"
      });
    `;
    document.head.appendChild(widgetScript);

    // Видаляємо скрипти при розмонтуванні компоненту
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(widgetScript);
    };
  }, []);

  return (
    <div>
      {/* Кнопка для відображення віджету */}
      <button
        onClick={openScheduler}
        className="btn btn__border btn__border_primary"
        style={{
          color: "#00664e",
        }}
      >
        Termin vereinbaren
      </button>
      {/* Пустий div для монтування віджету */}
      <div ref={schedulerRef}></div>
    </div>
  );
};

export default AppointmentScheduler;
